import {Box, Button} from '@mui/material';
import Typography from '@mui/material/Typography';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import MultilineTextField from '../../../../shared-components/MultilineTextField';

function DescriptionSettings(
    {
        header,
        description,
        defaultDescription,
        onDescriptionChange,
        fieldLabel = 'Description',
        saveButtonText = 'Save description',
        rows,
        canBeEmpty = false
    }) {
    const [text, setText] = useState(description);
    const actions = text !== defaultDescription && defaultDescription
        ? [
            {
                label: 'Revert to Default Description',
                onClick: () => setText(defaultDescription)
            }
        ]
        : [];

    useEffect(() => {
        setText(description);
    }, [description]);

    // AD-2696, AD-2712: only a box marked canBeEmpty (Dietary Needs) can be saved empty.
    const isEmptyRefused = !canBeEmpty && !text?.trim();

    return (
        <Box>
            {header
                ? <Typography variant="h6" fontWeight="bold" gutterBottom>{header}</Typography>
                : null
            }
            <MultilineTextField
                label={fieldLabel}
                value={text}
                onChange={setText}
                actions={actions}
                rows={rows}
            />
            {description !== text && (
                <>
                    {isEmptyRefused && (
                        <Typography variant="body2" color="error" sx={{mt: 1}}>
                            Description cannot be empty
                        </Typography>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={isEmptyRefused}
                        onClick={() => onDescriptionChange(text)}
                        sx={{
                            marginTop: 1,
                            backgroundColor: '#186BBE',
                            boxShadow: 'none',
                            width: { xs: '100%', sm: 'auto' },
                            '&:hover': {
                                backgroundColor: '#155FA7',
                                boxShadow: 'none'
                            }
                        }}
                    >
                        {saveButtonText}
                    </Button>
                </>
            )}
        </Box>
    );
}

DescriptionSettings.propTypes = {
    header: PropTypes.string,
    description: PropTypes.string,
    defaultDescription: PropTypes.string,
    onDescriptionChange: PropTypes.func,
    fieldLabel: PropTypes.string,
    saveButtonText: PropTypes.string,
    rows: PropTypes.number,
    canBeEmpty: PropTypes.bool
};

export default DescriptionSettings;
